// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"24bb577a","134":"71e208a9","167":"10a1421d","766":"6c50ed73"}[chunkId] + ".css";
};